import { render, staticRenderFns } from "./warnings-list.component.vue?vue&type=template&id=27335f18"
import script from "./warnings-list.component.ts?vue&type=script&lang=ts&external"
export * from "./warnings-list.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27335f18')) {
      api.createRecord('27335f18', component.options)
    } else {
      api.reload('27335f18', component.options)
    }
    module.hot.accept("./warnings-list.component.vue?vue&type=template&id=27335f18", function () {
      api.rerender('27335f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/warnings-list/warnings-list.component.vue"
export default component.exports